import {AnonymousRegistration, NormalRegistration} from "@web-libs/features/auth/main/domain/auth.types";
import {birthdayToString} from "@web-libs/core/shared-domain/values/birthday";

export type RegisterDTO = {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    instId: string;
    birth: string;
    registerType: "APP";
    mobile?: string;
    specializationId?: string;
}

export const parseRegisterDTO = (registration: NormalRegistration): RegisterDTO => {
    return {
        firstName: registration.firstName,
        lastName: registration.lastName,
        email: registration.email,
        password: registration.password,
        instId: registration.institutionId,
        registerType: "APP",
        birth: birthdayToString(registration.birthday),
        mobile: registration.mobile,
        specializationId: registration.specializationId ? registration.specializationId : undefined
    }
}

export type AnonymousRegisterDTO = {
    username: string;
    password: string;
    instId: string;
    specializationId?: string;
}

export const parseAnonymousRegisterDTO = (registration: AnonymousRegistration): AnonymousRegisterDTO => {
    return {
        username: registration.username,
        password: registration.password,
        instId: registration.institutionId,
        specializationId: registration.specializationId ? registration.specializationId : undefined
    }
}
